import styled from 'styled-components';
import Typography from '../Typography/Typography';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  max-height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  padding-right: min(0px, calc(100vw - 100%));
  font-size: 20px;

  --background: #fff;
  --border: #e0e0e0;
  --color: #262123;
  --shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14),
    0px 9px 46px 8px rgba(0, 0, 0, 0.12);

  &.darkMode {
    --background: rgb(12, 12, 12, 0.95);
    --border: #343434;
    --color: #f0f0f0;
  }
`;

export const Inner = styled.div`
  max-width: 1700px;
  margin: auto;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--color);

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const ModalBody = styled.div`
  background-color: var(--background);
  padding-bottom: 10px;
  min-width: 450px;
  max-width: 70vw;
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
  border-radius: 5px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;

  @media (max-width: 800px) {
    min-width: 80vw;
    border: none;
    box-shadow: none;
    margin: auto;
  }
`;

export const Header = styled.div`
  flex: 1;
  display: flex;
  padding: 5px 7px 5px 15px;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
  border-bottom: 1px solid var(--border);
`;

export const Title = styled(Typography)`
  flex: 1;
  color: var(--color);
`;

export const HeaderActions = styled.div`
  width: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  i {
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;

    &:hover {
      color: gold;
    }

    &:active {
      bottom: 1px;
      left: 1px;
      position: relative;
    }
  }
`;

export const Content = styled.div`
  padding: 0;
  margin-bottom: 14px;
`;
